/**
 * The signed-in caller's token, when there is one, for stamping a consent record with a `user_id`.
 *
 * Read off `window.Clerk` rather than through `useAuth()` on purpose. The consent listeners live
 * in `cookiebot-script.tsx`, which is mounted as a *sibling* of `<ClerkProvider>`, not inside it —
 * calling the hook there would throw at render. Reaching for the global keeps that arrangement
 * intact, so a Clerk outage or a slow SDK load costs us the `user_id` stamp and nothing more.
 *
 * Never throws and never blocks: an anonymous visitor is the normal case, not an error. The
 * `user_id` only matters because `consent_id` is a per-browser cookie — it is what lets a decision
 * made here be found again when the same person is served from another browser.
 */
export async function getConsentAuthToken(): Promise<string | null> {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return (await window.Clerk?.session?.getToken()) ?? null;
  } catch {
    return null;
  }
}
